import { fork, all } from 'redux-saga/effects';
import partialRight from 'lodash.partialright';
import {
  adManagerSaga,
  displayAdsSaga,
  removeAdsSaga,
  addResizeListenerSaga,
  windowResizeSaga,
  watchResizeChannel
} from 'ducks/ads';
import { fetchCarSaga, fetchValuationSaga } from 'ducks/valuation';
/**
 * Root saga containing all sagas used in the application.
 *
 * @return {Generator} compilation of all sagas.
 */
export default function* rootSaga(context = {}) {
  const fn = partialRight(fork, context);

  yield all([
    fn(adManagerSaga),
    fn(displayAdsSaga),
    fn(removeAdsSaga),
    fn(addResizeListenerSaga),
    fn(windowResizeSaga),
    fn(watchResizeChannel),
    fn(fetchCarSaga),
    fn(fetchValuationSaga)
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js